import { AfterViewInit, Component, TemplateRef, ViewChild, inject } from '@angular/core';
import { Alert, AlertService, MbsPopupType, MbsSize, ModalService } from 'mbs-ui-kit';
import { Balance } from 'mbs-ui-shared@components/components/models/license.model';
import { RenewLicenseModalComponent } from 'mbs-ui-shared@components/licenses/components/renew-license-modal/renew-license-modal.component';
import { BALANCE_TOKEN } from 'mbs-ui-shared@components/licenses/tokens/balance.token';
import { LicensesFacade } from 'mbs-ui-shared@facades/licenses.facade';
import { Observable, filter, map, noop } from 'rxjs';

import { PaymentMethodButtonComponent } from 'mbs-ui-shared@components/licenses/components/payment-method-button/payment-method-button.component';

import { ButtonComponent } from 'mbs-ui-kit';

import { I18NextPipe } from 'angular-i18next';

@Component({
  selector: 'mbs-auto-renewal-alert',
  templateUrl: './auto-renewal-alert.component.html',
  imports: [ButtonComponent, I18NextPipe, PaymentMethodButtonComponent]
})
export class AutoRenewalAlertComponent implements AfterViewInit {
  private modalService = inject(ModalService);
  private alertService = inject(AlertService);
  private licensesFacade = inject(LicensesFacade);
  balance = inject<Observable<Balance>>(BALANCE_TOKEN);

  public readonly size = MbsSize;

  @ViewChild('autoRenewalFailedAlert', { static: true }) autoRenewalFailedAlert: TemplateRef<any>;

  public subscriptionEditLink = this.licensesFacade.subscriptionEditLink;

  public get isAutoPay(): Observable<boolean> {
    return this.balance.pipe(
      filter(Boolean),
      map((balance) => balance?.subscriptionEnabled)
    );
  }

  ngAfterViewInit() {
    const alert = new Alert({
      id: 'auto-renewal-alert',
      icon: true,
      content: this.autoRenewalFailedAlert,
      type: MbsPopupType.danger
    });

    this.alertService.alert(alert);
  }

  public openRenewModal() {
    this.modalService
      .openCustom(RenewLicenseModalComponent, {
        size: MbsSize.xl
      })
      .catch(noop);
  }
}
